import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./bioStyle.css";
import "aos/dist/aos.css";

export default function Bio() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "DJ - EMAN"
    }, []);

    return (
        <div className="bioContainer">
            <div className="videoBackground">
                <video autoPlay muted loop playsInline>
                    <source src="/video/bio.mp4" type="video/mp4" />
                </video>
                <div className="videoOverlay" />
            </div>
            <h1>Biographie</h1>
            <h2>1972 in Hof/ Saale geboren, hörte E-MAN bereits von Geburt an Songs von James Brown, Marvin Gaye und Jackson Five. So wurde ihm der Grundstock der Soul- und Blackmusik bereits in die Wiege gelegt.
                Schon früh träumte er von einer Karriere als Musiker. Diese nimmt Formen an, als er bereits im Alter von 18 Jahren unter dem Namen DJ El-Mar beginnt, in den örtlichen Diskotheken Platten aufzulegen. Dort übte er sich hauptsächlich in den Musikrichtungen Black, R&B, und Oldschool, freilich mit einem guten Schuss Club-Appeal. In der bunten Vielfalt der Musikszene findet DJ El-Mar immer mehr Gefallen an der Mixtur aus Black, R&B, Oldschool, Pop und Dancefloor.
                Nachdem er sich 1997 berufs - und familiärbedingt aus der Szene zurückzog, startete er sein Comeback im Jahr 2004 und beschallte die Clubs erneut. Schnell erkannte er auch Freude an House und elektronischer Tanzmusik und so kamen seine DJ-Ambitionen erstrecht in Fahrt. Seither steht er so jedes Wochenende unter dem Namen DJ E-MAN hinter seinen Turntables und rockt die Party in verschiedenen Diskotheken der Region.
                Sein wachsender Bekanntheitsgrad und sein Gespühr für die Stimmung des Publikums sorgten dafür, dass er auch mehr und mehr für Großveranstaltungen gebucht wurde. Mit seinem Style, seinem Herzschlag zur House- und elektronischen Tanzmusik, sowie einer gesunden Mischung aus fast allen Musikrichtungen, was die Jahrzehnte hergeben, gelingt es ihm heute immer wieder, den Abend zu einem unvergesslichen Erlebnis für jeden Club- und Partygänger zu machen.</h2>
            <hr />
            <h1>Referenzen</h1>
            <h2>• Seit 2005 viele Hochzeitsfeiern</h2>
            <h2>• Firmenevents von:
                <br/>Brose Basket
                <br/>Ugho
                <br/>Busunternehmen Mario Röttgen
                <br/>Dörfner
                <br/>Mediengruppe Oberfranken
                <br/>Reit- & Fahrverein Hof
                <br/>Sana Klinikum Hof
                <br/>Medika Hof
            </h2>
            <h2>• Clubs / Discotheken:
                <br/>Rockwerk Hof
                <br/>Madhouse Marktredwitz
                <br/>Music Legends Hof
                <br/>Frisco Bayreuth
                <br/>Dschäblins Bayreuth
                <br/>Dreefs Marktrodach
                <br/>Mojow Bamberg
                <br/>Bierpalast Hof
                <br/>U27 Hof
                <br/>P Club Hof
                <br/>Sky Lounge Bamberg
                <br/>Halifax Himmelkron
                <br/>U-Night Unterpreppach
                <br/>Nepomuk Altenkunstadt
                <br/>Tanzpalast Schwingen
                <br/>Seaside Weißenstadt
                <br/>7 One Tirschenreuth
                <br/>Bowlingbahn Kirchenlamitz
                <br/>Bellini Münchberg
                <br/>F Dorf
                <br/>Glashaus Adorf
                <br/>Prince Plauen
                <br/>Hexenfeuer Plauen
                <br/>Winterpalais Plauen
                <br/>Zero One Blankenstein
                <br/>Legendärer Letzter Wagen Plauen
                <br/>Arena Günzburg
                <br/>Apres Ski - St. Johann
                <br/>Zell am See
                <br/>Maria Alm
                <br/>Ischgl
                <br/>uvm.
            </h2>
            <h2>• Weitere Events:
                <br/>Glühweinparty <span class="additionalInformation">(Stadt Schwarzenbach an der Saale)</span>
                <br/>Silentparty <span class="additionalInformation">(Stadt Schwarzenbach an der Saale)</span>
                <br/>Wurlitzer Kärwa <span class="additionalInformation">(Club Stets Heiter)</span>
                <br/>Abschlussball <span class="additionalInformation">(FOS / BOS Hof)</span>
                <br/>Hofer Volksfest <span class="additionalInformation">(Stadt Hof)</span>
                <br/>Trucker Festival Limbach
                <br/>Bürgerfest Bayreuth <span class="additionalInformation">(Waikiki Bar)</span>
            </h2>
        </div>
    )
}
